import React from 'react';
import { FiX } from 'react-icons/fi';

export interface BusinessRulesDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BusinessRulesDrawer: React.FC<BusinessRulesDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <div
      className={`fixed top-0 right-0 h-full w-[450px] bg-white shadow-2xl border-l border-neutral-200 z-50 transform transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-neutral-200">
            <h2 className="text-xl font-semibold text-neutral-900">
              Regras de Negócio
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="text-neutral-400 hover:text-neutral-600 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            {/* DICT */}
            <div>
              <h3 className="text-sm font-bold text-neutral-900 mb-2">
                • DICT:
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">
                Score de risco baseado em chaves Pix e histórico de transações do Banco Central
              </p>
            </div>

            {/* RUFRA */}
            <div>
              <h3 className="text-sm font-bold text-neutral-900 mb-2">
                • RUFRA:
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">
                Registro de apontamentos de fraude financeira. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>

            {/* DIMENSA */}
            <div>
              <h3 className="text-sm font-bold text-neutral-900 mb-2">
                • DIMENSA:
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>

            {/* SIMILARIDADE */}
            <div>
              <h3 className="text-sm font-bold text-neutral-900 mb-2">
                • SIMILARIDADE:
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              </p>
            </div>

            {/* Análise de Risco */}
            <div className="border-t border-neutral-200 pt-6">
              <h3 className="text-base font-semibold text-neutral-900 mb-4">
                Análise de Risco
              </h3>
              <p className="text-sm text-neutral-600 mb-4">
                O sistema atribuiu o perfil individual de risco a esse cliente, baseado nas políticas listadas, índices e resultados de consultas.
              </p>
              <div className="grid grid-cols-3 gap-3">
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">✓</div>
                  <p className="text-sm font-medium text-green-700 mb-1">Aprovado</p>
                  <p className="text-xs text-green-600">Baixo risco, regras e índices que o sistema aprova</p>
                </div>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">⚠️</div>
                  <p className="text-sm font-medium text-yellow-700 mb-1">Análise</p>
                  <p className="text-xs text-yellow-600">Médio risco, risco que o sistema encaminha para análise</p>
                </div>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
                  <div className="text-2xl mb-2">✗</div>
                  <p className="text-sm font-medium text-red-700 mb-1">Reprovado</p>
                  <p className="text-xs text-red-600">Alto risco, regras e índices que o sistema reprova</p>
                </div>
              </div>
            </div>

            {/* Análise de PJ */}
            <div className="border-t border-neutral-200 pt-6">
              <h3 className="text-base font-semibold text-neutral-900 mb-4">
                Análise de PJ
              </h3>
              <p className="text-sm text-neutral-600 mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
              </p>
              <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4">
                <ul className="space-y-2 text-sm text-neutral-700">
                  <li className="flex items-start gap-2">
                    <span className="text-purple-600 mt-1">•</span>
                    <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-purple-600 mt-1">•</span>
                    <span>Sed do eiusmod tempor incididunt ut labore et dolore</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-purple-600 mt-1">•</span>
                    <span>Ut enim ad minim veniam, quis nostrud exercitation</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
